import { RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
    {
        path: '/',
        name: 'occ-landing',
        component: () => import('./open-casting-call-page.vue'),
        meta: { layout: 'blank-layout' },
        children: [
            {
                name: 'occ-upload',
                path: 'upload',
                component: () => import('./open-casting-call-video-upload-modal.vue'),
                props: route => ({
                    eager: true,
                    videoUploadUrl: route.query.videoUploadUrl,
                }),
            },
            {
                name: 'occ-tnc',
                path: 'tnc',
                component: () => import('./open-casting-call-tnc-modal.vue'),
                props: { eager: true }
            }
        ]
    }
]

export default routes;
